export class EventModel {
  static INVOLVEMENTS = {
    VICTIM: {
      CODE: 'VITIMA',
      DESC: 'Vítima',
    },
    CAUSER: {
      CODE: 'CAUSADOR',
      DESC: 'Causador',
    },
  };

  static TYPES = {
    CRASH: {
      CODE: 'crash',
      URL: 'crash',
      DESC: 'Colisão',
    },
    THIRD_PARTY_MONITORING: {
      CODE: 'third_party_monitoring',
      URL: 'third-party-monitoring',
      DESC: 'Acompanhamento terceiro',
    },
    DRIVER_MONITORING: {
      CODE: 'driver_monitoring',
      URL: 'driver-monitoring',
      DESC: 'Acompanhamento Condutor',
    },
    PROPERTY_DAMAGE: {
      CODE: 'property_damage',
      URL: 'property-damage',
      DESC: 'Dano patrimonial',
    },
    ROBBERY_AND_THEFT: {
      CODE: 'robbery_and_theft',
      URL: 'robbery-and-theft',
      DESC: 'Roubo e furto',
    },
    GLASS_AND_ACCESSORIES: {
      CODE: 'glass_and_accessories',
      URL: 'glass-and-accessories',
      DESC: 'Vidros e acessórios',
    },
    NATURAL_PHENOMENA: {
      CODE: 'natural_phenomena',
      URL: 'natural-phenomena',
      DESC: 'Fenômenos da natureza',
    },
    FIRE: {
      CODE: 'fire',
      URL: 'fire',
      DESC: 'Incêndio',
    },
    ROLLOVER: {
      CODE: 'rollover',
      URL: 'rollover',
      DESC: 'Tombamento',
    },
  };

  static SUB_TYPES = {
    IMPLEMENT: {
      CODE: 'implement',
      URL: 'implement',
      DESC: 'Acompanhamento de Implementos',
    },
  };

  static VEHICLE_TYPES = {
    CAR: {
      CODE: 'car',
      DESC: 'Carro',
    },
    MOTORCYCLE: {
      CODE: 'motorcycle',
      DESC: 'Moto',
    },
    TRUCK: {
      CODE: 'truck',
      DESC: 'Caminhão',
    },
    BUS: {
      CODE: 'bus',
      DESC: 'Ônibus',
    },
    BIKE: {
      CODE: 'bike',
      DESC: 'Bicicleta',
    },
    // AGGREGATE: {
    //   CODE: 'aggregate',
    //   DESC: 'Agregado',
    // },
    // TRUCK_AGGREGATE: {
    //   CODE: 'truck_aggregate',
    //   DESC: 'Caminhão e Agregado',
    // },
  };

  static THIRD_PARTY_RELATION = {
    0: {
      CODE: 'victim',
      DESC: 'Vítima',
    },
    1: {
      CODE: 'causer',
      DESC: 'Causador',
    },
  };

  //$NomeEtapas = array("1" => "COMUNICAÇÃO", "2" => "ABERTURA", "3" => "VISTORIA DO EVENTO", "5" => "SINDICÂNCIA", "6" => "LIBERAÇÃO",    "12" => "OFICINA", "13" => "PEÇAS", "14" => "SERVIÇO", "15" => "VISTORIA DE ENTREGA", "16" => "ENTREGA",    "21" => "PROGRAMAÇÃO DE PAGAMENTO", "22" => "TERMO DE INDENIZAÇÃO", "23" => "DOCUMENTAÇÃO PARA INDENIZAÇÃO", "24" => "PAGAMENTO");
  static STEPS = {
    COMMUNICATION: {
      CODE: 'communication',
      CODE_2: 1,
      DESC: 'Comunicação do Sinistro',
      DESC_ADMIN: 'Comunicação do Sinistro',
    },
    OPENING: {
      CODE: 'opening',
      CODE_2: 2,
      DESC: 'Documentação de Abertura',
      DESC_ADMIN: 'Documentação de Abertura',
    },
    INSPECTION: {
      CODE: 'inspection',
      CODE_2: 3,
      DESC: 'Vistoria de Constatação e Regulagem',
      DESC_ADMIN: 'Vistoria de Constatação e Regulagem',
    },
    INQUIRY: {
      CODE: 'inquiry',
      CODE_2: 5,
      DESC: 'Análise',
    },
    LIBERATION: {
      CODE: 'liberation',
      CODE_2: 6,
      DESC: 'Decisão de Cobertura',
      DESC_ADMIN: 'Decisão de Cobertura',
    },
    COMPENSATION_DOCUMENTATION: {
      CODE: 'compensation_documentation',
      CODE_2: 23,
      DESC: 'Documentação para indenização',
    },
    PAYMENT_SCHEDULE: {
      CODE: 'payment_schedule',
      CODE_2: 21,
      DESC: 'Programação de pagamento',
    },
    COMPENSATION_TERM: {
      CODE: 'compensation_term',
      CODE_2: 22,
      DESC: 'Termo de indenização',
    },
    PAYMENT: {
      CODE: 'payment',
      CODE_2: 24,
      DESC: 'Pagamento',
    },
    CAR_REPAIR: {
      CODE: 'car_repair',
      CODE_2: 12,
      DESC: 'Autorização para Oficina',
      DESC_ADMIN: 'Autorização para Oficina ',
    },
    CAR_PARTS: {
      CODE: 'car_parts',
      CODE_2: 13,
      DESC: 'Peças',
      DESC_ADMIN: 'Compra de Peças',
    },
    SERVICE: {
      CODE: 'service',
      CODE_2: 14,
      DESC: 'Reparação',
      DESC_ADMIN: 'Reparação',
    },
    INSPECTION_DELIVERY: {
      CODE: 'inspection_delivery',
      CODE_2: 15,
      DESC: 'Vistoria de entrega',
    },
    DELIVERY: {
      CODE: 'delivery',
      CODE_2: 16,
      DESC: 'Entrega',
    },
  };

  static SUB_STEPS = {
    INQUIRY_INTERNAL_ANALYSIS: {
      CODE: 'inquiry_internal_analysis',
      DESC: 'Análise Interna',
      STEP: 'inquiry',
      REQUIRED_FIELD: 'inquiryInternalAnalysisRequired',
      CONCLUSION_FIELD: 'inquiryInternalAnalysisConclusionAt',
    },
    INQUIRY_LEGAL_ANALYSIS: {
      CODE: 'inquiry_legal_analysis',
      DESC: 'Análise Jurídica',
      STEP: 'inquiry',
      REQUIRED_FIELD: 'inquiryLegalAnalysisRequired',
      CONCLUSION_FIELD: 'inquiryLegalAnalysisConclusionAt',
    },
    INQUIRY_EXPERTISE: {
      CODE: 'inquiry_expertise',
      DESC: 'Sindicância',
      STEP: 'inquiry',
      REQUIRED_FIELD: 'inquiryExpertiseRequired',
      CONCLUSION_FIELD: 'inquiryExpertiseConclusionAt',
    },
    CAR_PARTS_BUDGET: {
      CODE: 'car_parts_budget',
      DESC: 'Orçamento',
      STEP: 'car_parts',
      REQUIRED_FIELD: 'carPartsBudgetRequired',
      CONCLUSION_FIELD: 'carPartsBudgetConclusionAt',
    },
    CAR_PARTS_CAPTATION: {
      CODE: 'car_parts_captation',
      DESC: 'Captação',
      STEP: 'car_parts',
      REQUIRED_FIELD: 'carPartsCaptationRequired',
      CONCLUSION_FIELD: 'carPartsCaptationConclusionAt',
    },
    CAR_PARTS_DELIVERY: {
      CODE: 'car_parts_delivery',
      DESC: 'Entrega',
      STEP: 'car_parts',
      REQUIRED_FIELD: 'carPartsDeliveryRequired',
      CONCLUSION_FIELD: 'carPartsDeliveryConclusionAt',
    },
    SERVICE_BODYWORK: {
      CODE: 'service_bodywork',
      DESC: 'Funilaria',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceBodyworkRequired',
      CONCLUSION_FIELD: 'serviceBodyworkConclusionAt',
    },
    SERVICE_ALIGNMENT_GEOMETRY: {
      CODE: 'service_alignment_geometry',
      DESC: 'Alinhamento e Geometria',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceAlignmentGeometryRequired',
      CONCLUSION_FIELD: 'serviceAlignmentGeometryConclusionAt',
    },
    SERVICE_PAINTING: {
      CODE: 'service_painting',
      DESC: 'Pintura',
      STEP: 'service',
      REQUIRED_FIELD: 'servicePaintingRequired',
      CONCLUSION_FIELD: 'servicePaintingConclusionAt',
    },
    SERVICE_MECHANICS: {
      CODE: 'service_mechanics',
      DESC: 'Mecânica',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceMechanicsRequired',
      CONCLUSION_FIELD: 'serviceMechanicsConclusionAt',
    },
    SERVICE_ELECTRICAL: {
      CODE: 'service_electrical',
      DESC: 'Elétrica',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceElectricalRequired',
      CONCLUSION_FIELD: 'serviceElectricalConclusionAt',
    },
    SERVICE_UPHOLSTERY: {
      CODE: 'service_upholstery',
      DESC: 'Tapeçaria',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceUpholsteryRequired',
      CONCLUSION_FIELD: 'serviceUpholsteryConclusionAt',
      VEHICLE_TYPE: 'truck',
    },
    SERVICE_CHASSIS_ALIGNMENT: {
      CODE: 'service_chassis_alignment',
      DESC: 'Alinhamento de Chassi',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceChassisAlignmentRequired',
      CONCLUSION_FIELD: 'serviceChassisAlignmentConclusionAt',
      VEHICLE_TYPE: 'truck',
    },
    SERVICE_REPLACEMENT: {
      CODE: 'service_replacement',
      DESC: 'Troca',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceReplacementRequired',
      CONCLUSION_FIELD: 'serviceReplacementConclusionAt',
    },
    SERVICE_COMPLEMENTARY: {
      CODE: 'service_complementary',
      DESC: 'Serviços Complementares',
      STEP: 'service',
      REQUIRED_FIELD: 'serviceComplementaryRequired',
      CONCLUSION_FIELD: 'serviceComplementaryConclusionAt',
    },
  };

  /** ETAPAS DO ACIONAMENTO */
  //$NomeEtapasAcionamento = array("" => "TERMO DE ACIONAMENTO", "1" => "CONFIRMAÇÃO", "13" => "DADOS DO TERCEIRO", "2" => "CONDUTOR DO VEÍCULO", "3" => "ENVOLVIDOS NO ACIDENTE", "4" => "LOCAL DO OCORRIDO", "6" => "TESTEMUNHAS", "7" => "ESCLARECIMENTO SOBRE OS FATOS", "8" => "DESCRIÇÃO DO OCORRIDO", "9" => "FOTOS", "10" => "INFORMAÇÕES IMPORTANTES SOBRE SEU EVENTO", "11" => "VERIFICAÇÃO DE IDENTIDADE", "5" => "BOLETIM DE OCORRÊNCIA", "12" => "EM ANÁLISE");
  static TRIGGER_STEPS = {
    TRIGGER_TERM: {
      CODE: 'trigger_term',
      CODE_2: null,
      DESC: 'Termo de acionamento',
    },
    CONFIRMATION: {
      CODE: 'confirmation',
      CODE_2: 1,
      DESC: 'Confirmação',
    },
    THIRD_PARTY_DATA: {
      CODE: 'third_party_data',
      CODE_2: 13,
      DESC: 'Dados do terceiro',
    },
    DRIVER_VEHICLE: {
      CODE: 'driver_vehicle',
      CODE_2: 2,
      DESC: 'Condutor do veículo',
    },
    ACCIDENT_INVOLVED: {
      CODE: 'accident_involved',
      CODE_2: 3,
      DESC: 'Envolvidos no acidente',
    },
    INCIDENT_LOCATION: {
      CODE: 'incident_location',
      CODE_2: 4,
      DESC: 'Local do ocorrido',
    },
    WITNESSES: {
      CODE: 'witnesses',
      CODE_2: 6,
      DESC: 'Testemunhas',
    },
    CLARIFICATION_FACTS: {
      CODE: 'clarification_facts',
      CODE_2: 7,
      DESC: 'Esclarecimento sobre os fatos',
    },
    DESCRIPTION_INCIDENT: {
      CODE: 'description_incident',
      CODE_2: 8,
      DESC: 'Descrição do ocorrido',
    },
    PHOTOS: {
      CODE: 'photos',
      CODE_2: 9,
      DESC: 'Fotos',
    },
    REPAIR_BUDGET: {
      CODE: 'repair_budget',
      CODE_2: 14,
      DESC: 'Orçamento do Reparo',
    },
    IMPORTANT_INFORMATION: {
      CODE: 'important_information',
      CODE_2: 10,
      DESC: 'Informações importantes sobre seu evento',
    },
    IDENTITY_VERIFICATION: {
      CODE: 'identity_verification',
      CODE_2: 11,
      DESC: 'Verificação de identidade',
    },
    OCCURRENCE_REPORT: {
      CODE: 'occurrence_report',
      CODE_2: 5,
      DESC: 'Boletim de ocorrência',
    },
    IN_ANALYSIS: {
      CODE: 'in_analysis',
      CODE_2: 12,
      DESC: 'Em análise',
    },
  };

  static STATUS = {
    DONE: {
      CODE: 'done',
      DESC: 'Finalizado',
      CLASS: 'success',
    },
    PARTIAL_AGREEMENT: {
      CODE: 'partial_agreement',
      DESC: 'Indenização parcial',
      CLASS: 'success',
    },
    FULL_AGREEMENT: {
      CODE: 'full_agreement',
      DESC: 'Indenização total',
      CLASS: 'success',
    },
    REPAIR_ONLY_THIRD_PARTY: {
      CODE: 'repair_only_third_party',
      DESC: 'Reparar apenas terceiro',
      CLASS: 'success',
    },
    RECOVERED_WITHOUT_TRIGGERING: {
      CODE: 'recovered_without_triggering',
      DESC: 'Recuperado sem acionamento',
      CLASS: 'success',
    },
    RECOVERED_WITH_TRIGGERING: {
      CODE: 'recovered_with_triggering',
      DESC: 'Recuperado com acionamento',
      CLASS: 'success',
    },
    DENIED: {
      CODE: 'denied',
      DESC: 'Negado',
      CLASS: 'danger',
    },
    SUSPENDED: {
      CODE: 'suspended',
      DESC: 'Suspenso',
      CLASS: 'warning',
    },
    NO_COMUNICATION: {
      CODE: 'no_comunication',
      DESC: 'Sem comunicação',
      CLASS: 'warning',
    },
    EXPIRED: {
      CODE: 'expired',
      DESC: 'Prazo expirado',
      CLASS: 'warning',
    },
    CANCELLED: {
      CODE: 'cancelled',
      DESC: 'Cancelado',
      CLASS: 'danger',
    },
    IN_PROGRESS: {
      CODE: 'in_progress',
      DESC: 'Em andamento',
      CLASS: 'info',
    },
  };

  static TASK_STATUS = {
    NEW: {
      CODE: 'new',
      DESC: 'Pendente',
      CLASS: 'info',
      COLOR: '#009ef7',
    },
    FINISHED: {
      CODE: 'finished',
      DESC: 'Finalizada',
      CLASS: 'success',
      COLOR: '#47be7d',
    },
    CANCELED: {
      CODE: 'canceled',
      DESC: 'Cancelada',
      CLASS: 'danger',
      COLOR: '#d9214e',
    },
  };

  static VEHICLE_DRIVER = {
    ASSOCIATE: {
      CODE: 'ASSOCIADO',
      DESC: 'Associado',
    },
    THIRD_PARTY: {
      CODE: 'TERCEIRO',
      DESC: 'Terceiro',
    },
    OTHER: {
      CODE: 'OUTRO',
      DESC: 'Outro',
    },
  };

  static VEHICLE_USAGE = {
    PARTICULAR: {
      CODE: 'PARTICULAR',
      DESC: 'Particular/Lazer',
    },
    COMMERCIAL: {
      CODE: 'COMMERCIAL',
      DESC: 'Comercial',
    },
  };

  static VEHICLE_USAGE_NEW = {
    APP_DRIVER: {
      CODE: 'MOTORISTA_APP',
      DESC: 'Motorista de App',
    },
    TAXI: {
      CODE: 'TAXI',
      DESC: 'Táxi',
    },
    DELIVERY_FREIGHT: {
      CODE: 'ENTREGAS_FRETE',
      DESC: 'Entregas/Frete',
    },
  };

  static LOCATION_INCIDENT_ROAD_TYPES = {
    PAVED_ROAD: {
      CODE: 'paved_road',
      DESC: 'Rua/Avenida/Rodovia – Pavimentada',
    },
    UNPAVED_ROAD: {
      CODE: 'unpaved_road',
      DESC: 'Rua/Avenida/Rodovia – Não Pavimentada',
    },
    PARKING_LOT: {
      CODE: 'parking_lot',
      DESC: 'Estacionamento (mercado, shopping, etc.)',
    },
    RESIDENCE_GARAGE: {
      CODE: 'residence_garage',
      DESC: 'Residência/Garagem',
    },
  };

  static TRUCK_SET_TYPES = {
    LS: {
      CODE: 'LS',
      DESC: 'LS',
    },
    BITREM: {
      CODE: 'BITREM',
      DESC: 'Bitrem',
    },
    RODOTREM: {
      CODE: 'RODOTREM',
      DESC: 'Rodotrem',
    },
  };

  static TRUCK_IMPLEMENT_POSITIONS = {
    FIRST_TRAILER: {
      CODE: 'first_trailer',
      DESC: 'Placa da 1ª carreta',
    },
    DOLLY: {
      CODE: 'dolly',
      DESC: 'Placa do Dolly',
    },
    SECOND_TRAILER: {
      CODE: 'second_trailer',
      DESC: 'Placa da 2ª carreta',
    },
  };

  static LOCATION_FIELDS = {
    incident_location: {
      state: 'locationIncidentState',
      city: 'locationIncidentCity',
      locationIncidentRoadType: 'locationIncidentRoadType',
      zipCode: 'locationIncidentZipCode',
      district: 'locationIncidentDistrict',
      address: 'locationIncidentAddress',
      addressNumber: 'locationIncidentAddressNumber',
      addressAdditional: 'locationIncidentaAdressAdditional',
    },
    coming_from: {
      state: 'comingFromState',
      city: 'comingFromCity',
      zipCode: 'comingFromZipCode',
      district: 'comingFromDistrict',
      address: 'comingFromAddress',
      addressNumber: 'comingFromAddressNumber',
      addressAdditional: 'comingFromAddressAdditional',
    },
    going_to: {
      state: 'goingToState',
      city: 'goingToCity',
      zipCode: 'goingToZipCode',
      district: 'goingToDistrict',
      address: 'goingToAddress',
      addressNumber: 'goingToAddressNumber',
      addressAdditional: 'goingToAddressAdditional',
    },
  };

  // static STEP_PHOTOS_FILES = [
  //   {
  //     name: 'Foto 1',
  //     required: true,
  //   },
  //   {
  //     name: 'Foto 2',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 3',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 4',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 5',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 6',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 7',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 8',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 9',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 10',
  //     required: false,
  //   },
  // ];

  // static OCCURRENCE_REPORT_PHOTOS = [
  //   {
  //     name: 'B.O',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 2',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 3',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 4',
  //     required: false,
  //   },
  //   {
  //     name: 'Foto 5',
  //     required: false,
  //   },
  // ];

  // static INSPECTION_PHOTOS = [
  //   {
  //     name: 'Frente do Veículo',
  //     required: true,
  //   },
  //   {
  //     name: 'Para-Brisa Dianteiro',
  //     required: true,
  //   },
  //   {
  //     name: 'Farol Dianteiro (Lado Motorista)',
  //     required: true,
  //   },
  //   {
  //     name: 'Pneu Dianteiro (Lado Motorista)',
  //     required: false,
  //   },
  //   {
  //     name: 'L-Dianteira (Lado Motorista)',
  //     required: false,
  //   },
  //   {
  //     name: 'Lateral do Veículo (Lado Motorista)',
  //     required: false,
  //   },
  //   {
  //     name: 'L-Traseira (Lado Motorista)',
  //     required: false,
  //   },
  //   {
  //     name: 'Pneu Traseiro (Lado Motorista)',
  //     required: false,
  //   },
  //   {
  //     name: 'Lanterna Traseira (Lado Motorista)',
  //     required: false,
  //   },
  //   {
  //     name: 'Vidro Traseiro',
  //     required: false,
  //   },
  //   {
  //     name: 'Traseira do Veículo',
  //     required: false,
  //   },
  //   {
  //     name: 'Lanterna Traseira (Lado Passageiro)',
  //     required: false,
  //   },
  //   {
  //     name: 'Pneu Traseiro (Lado Passageiro)',
  //     required: false,
  //   },
  //   {
  //     name: 'L-Traseira (Lado Passageiro)',
  //     required: false,
  //   },
  //   {
  //     name: 'Lateral do Veículo (Lado Passageiro)',
  //     required: false,
  //   },
  //   {
  //     name: 'L-Dianteira (Lado Passageiro)',
  //     required: false,
  //   },
  //   {
  //     name: 'Pneu Dianteiro (Lado Passageiro)',
  //     required: false,
  //   },
  //   {
  //     name: 'Farol Dianteiro (Lado Passageiro)',
  //     required: false,
  //   },
  //   {
  //     name: 'Chave do Veículo Frente',
  //     required: false,
  //   },
  //   {
  //     name: 'Chave do Veículo Verso',
  //     required: false,
  //   },
  // ];

  static INSPECTION_RESPONSABLES = {
    USER: {
      CODE: 'user',
      DESC: 'Associado',
    },
    COMPANY: {
      CODE: 'company',
      DESC: 'Associação',
    },
    THIRD_PARTY: {
      CODE: 'third_party',
      DESC: 'Terceiro',
    },
  };

  static LIBERATION_RESULT = {
    APPROVED: {
      CODE: 'approved',
      DESC: 'Liberado',
      CLASS: 'success',
    },
    DENIED: {
      CODE: 'denied',
      DESC: 'Negado',
      CLASS: 'danger',
    },
  };

  static LIBERATION_PARTICIPATION = {
    COMPANY: {
      CODE: 'company',
      DESC: 'Para Associação',
    },
    CAR_REPAIR: {
      CODE: 'car_repair',
      DESC: 'Oficina',
    },
    FREE: {
      CODE: 'free',
      DESC: 'Isento',
    },
  };

  static LIBERATION_PAYMENT_STATUS = {
    PENDING: {
      CODE: 'pending',
      DESC: 'Pendente',
      CLASS: 'warning',
    },
    PAID: {
      CODE: 'paid',
      DESC: 'Efetuado',
      CLASS: 'success',
    },
  };

  static LIBERATION_PAYMENT_TYPES = {
    BANK_SLIP: {
      CODE: 'bank_slip',
      DESC: 'Boleto Bancário',
    },
    CREDIT_CARD: {
      CODE: 'credit_card',
      DESC: 'Cartão de Crédito',
    },
    PIX: {
      CODE: 'PIX',
      DESC: 'Pix',
    },
  };

  static SERVICE_TYPES = {
    BODYWORK: {
      CODE: 'bodywork',
      DESC: 'Funilária',
    },
    MECHANICS: {
      CODE: 'mechanics',
      DESC: 'Mecânica',
    },
    ELECTRICAL: {
      CODE: 'electrical',
      DESC: 'Elétrica',
    },
    PAINTING: {
      CODE: 'painting',
      DESC: 'Pintura',
    },
    BODYWORK_AND_PAINTING: {
      CODE: 'bodywork_and_painting',
      DESC: 'Funilaria/Pintura',
    },
    REPLACEMENT: {
      CODE: 'replacement',
      DESC: 'Troca',
    },
    REPLACEMENT_AND_PAINTING: {
      CODE: 'replacement_and_painting',
      DESC: 'Troca/Pintura',
    },
    REMOVAL_AND_INSTALLATION: {
      CODE: 'removal_and_installation',
      DESC: 'Remoção/Instalação',
    },
    REPAIR: {
      CODE: 'repair',
      DESC: 'Reparação',
    },
    PACKAGE: {
      CODE: 'package',
      DESC: 'Pacote',
    },
    IMPACT: {
      CODE: 'impact',
      DESC: 'Impacto',
    },
    UNDER_ANALYSIS: {
      CODE: 'under_analysis',
      DESC: 'Sob Análise',
    },
    WITHOUT_SUPPORT: {
      CODE: 'without_support',
      DESC: 'Sem Amparo',
    },
  };

  static PART_TYPES = {
    PACKAGE: {
      CODE: 'package',
      DESC: 'Pacote',
    },
  };

  static QUOTATION_TYPES = {
    BOTH: {
      CODE: 'parts_and_services',
      DESC: 'Peças e Serviços',
    },
    PART: {
      CODE: 'part',
      DESC: 'Peças',
    },
    SERVICE: {
      CODE: 'service',
      DESC: 'Serviços',
    },
  };

  static QUOTATION_STATUS = {
    PENDING: {
      CODE: 'pending',
      DESC: 'Em andamento',
      CLASS: 'info',
    },
    SUCCESS: {
      CODE: 'success',
      DESC: 'Concluída',
      CLASS: 'success',
    },
    CANCELED: {
      CODE: 'canceled',
      DESC: 'Cancelada',
      CLASS: 'danger',
    },
  };

  static QUOTATION_PART_STATUS = {
    NEW: {
      CODE: 'new',
      DESC: 'Original Nova',
    },
    USED: {
      CODE: 'used',
      DESC: 'Original Usada',
    },
    NEW_IMPORTED: {
      CODE: 'new_imported',
      DESC: 'Nova Importada',
    },
    USED_IMPORTED: {
      CODE: 'used_imported',
      DESC: 'Usada Importada',
    },
    PACKAGE: {
      CODE: 'package',
      DESC: 'Pacote',
    },
  };

  static QUOTATION_MP = {
    BANK_SLIP: {
      CODE: 'bank_slip',
      DESC: 'Boleto Bancário',
    },
    PIX: {
      CODE: 'pix',
      DESC: 'Pix',
    },
    CREDIT_CARD: {
      CODE: 'credit_card',
      DESC: 'Cartão de Crédito',
    },
  };

  static ACQUISITION_MP_TYPES = {
    NFE: {
      CODE: 'nfe',
      DESC: 'NFE',
    },
    SLIP: {
      CODE: 'slip',
      DESC: 'Boleto',
    },
    OTHER: {
      CODE: 'other',
      DESC: 'Outro',
    },
  };

  static ACQUISITION_MP = {
    // NFE: {
    //   CODE: 'nfe',
    //   DESC: 'NFE',
    // },
    SLIP: {
      CODE: 'slip',
      DESC: 'Boleto',
    },
    CARD: {
      CODE: 'card',
      DESC: 'Cartão',
    },
    PIX: {
      CODE: 'pix',
      DESC: 'Pix',
    },
    CASH: {
      CODE: 'cash',
      DESC: 'Dinheiro',
    },
  };

  // ABAM
  static PLANS = {
    POP: {
      CODE: 'pop',
      DESC: 'Pop',
    },
    ABAM: {
      CODE: 'abam',
      DESC: 'Abam',
    },
    PRIME: {
      CODE: 'prime',
      DESC: 'Prime',
    },
  };

  static DAMAGE_CLASSIFICATION = {
    SMALL: {
      CODE: 'small',
      DESC: 'Pequena Monta',
    },
    MEDIUM: {
      CODE: 'medium',
      DESC: 'Média Monta',
    },
    LARGE: {
      CODE: 'large',
      DESC: 'Grande Monta',
    },
  };

  static REPORT_OPTIONS = {
    EVENTS: {
      CODE: 'events',
      DESC: 'Eventos',
    },
    EVENTS_FINANCIAL: {
      CODE: 'events_financial',
      DESC: 'Eventos Financeiro',
    },
    EVENTS_PARTS: {
      CODE: 'events_parts',
      DESC: 'Eventos Peças',
    },
    EVENTS_PARTS_RECEIVED: {
      CODE: 'events_parts_received',
      DESC: 'Eventos Peças Recebidas',
    },
    EVENTS_SERVICES: {
      CODE: 'events_services',
      DESC: 'Eventos Serviços',
    },
    EVENTS_SERVICES_PENDING_BY_CATEGORY: {
      CODE: 'events_services_pending_by_category',
      DESC: 'Serviços Pendentes/Categoria',
    },
    REGRESSIONS: {
      CODE: 'regressions',
      DESC: 'Regressos',
    },
    REGRESSIONS_INSTALLMENTS: {
      CODE: 'regressions_installments',
      DESC: 'Regressos Parcelas',
    },
    PAYMENTS: {
      CODE: 'payments',
      DESC: 'Links de Pagamento',
    },
    INSPECTIONS_ONLINE: {
      CODE: 'inspections_online',
      DESC: 'Vistorias',
    },
    EVENTS_STEP_TIME: {
      CODE: 'events_step_time',
      DESC: 'Eventos Tempo em Cada Etapa',
    },
    EVENTS_SAVINGS_BY_EVENT: {
      CODE: 'events_savings_by_event',
      DESC: 'Economia em Cotações por Evento',
    },
    EVENTS_SAVINGS_BY_EVENT_PERIOD: {
      CODE: 'events_savings_by_event_period',
      DESC: 'Economia por Evento x Período',
    },
    EVENTS_VOLUNTARY_COOPERATIVE_COST: {
      CODE: 'events_voluntary_cooperative_cost',
      DESC: 'Voluntário X Cooperativa X Custo',
    },
  };

  static PART_SERVICE_PAYMENT_OPTIONS = [
    {
      CODE: 'fatured',
      DESC: 'Faturado',
    },
    {
      CODE: 'not_fatured',
      DESC: 'Não Faturado',
    },
    {
      CODE: 'devolved',
      DESC: 'Devolvido',
    },
    {
      CODE: 'paid',
      DESC: 'Pago',
    },
  ];

  static SGA_INTEGRATION_OPTIONS = {
    TYPE_1: {
      CODE: 'type_1',
      DESC: 'Tipo 1 - Associação não registra evento no S.G.A',
    },
    TYPE_2: {
      CODE: 'type_2',
      DESC: 'Tipo 2 - Abre o evento no S.G.A (Associado / Terceiro)',
    },
  };

  static COMPANY_TYPES = {
    DEFAULT: {
      CODE: 'default',
      DESC: 'Padrão',
    },
    INSURANCE: {
      CODE: 'insurance',
      DESC: 'Seguradora',
    },
  };

  static DAYS_TYPES = {
    CALENDAR: {
      CODE: 'calendar',
      DESC: 'Dias corridos',
    },
    BUSINESS: {
      CODE: 'business',
      DESC: 'Dias úteis',
    },
  };

  static FULL_AGREEMENT_CALCULATION_TYPES = {
    INTEGRAL: {
      CODE: 'integral',
      DESC: 'Integral',
    },
    RESIDUAL: {
      CODE: 'residual',
      DESC: 'Residual',
    },
  };

  static THIRD_PARTY_TYPES = {
    OTHER_VEHICLE: {
      CODE: 'other_vehicle',
      DESC: 'Outro veículo',
    },
    PROPERTY_DAMAGE: {
      CODE: 'property_damage',
      DESC: 'Dano patrimonial',
    },
  };

  //   const PAINT_TYPES = [
  //     'COMMON' => ['CODE' => 'common', 'DESC' => 'Comum'],
  //     'METALLIC' => ['CODE' => 'metallic', 'DESC' => 'Metálica'],
  //     'PEARLED' => ['CODE' => 'pearled', 'DESC' => 'Perolizada']
  // ];

  static PAINT_TYPES = {
    COMMON: {
      CODE: 'common',
      DESC: 'Comum',
    },
    METALLIC: {
      CODE: 'metallic',
      DESC: 'Metálica',
    },
    PEARLED: {
      CODE: 'pearled',
      DESC: 'Perolizada',
    },
  };
}

export interface EventFiltersModel {
  searchFilter?: string;
  statusFilter?: string;
  stepFilter?: string;
  eventStepStatusFilter?: string;
  subStepFilter?: string;
  labelFilter?: any;
  voluntaryFilter?: any;
  regionalFilter?: any;
  cooperativeFilter?: any;
  supplierFilter?: any;
  assigneeFilter?: any;
  externalProtocolFilter?: string;
  vehicleTypeFilter?: string;
  truckSetTypeFilters?: string[];
  truckImplementPositionFilters?: string[];
  filterDs?: any;
  filterDe?: any;
  source?: 'extra-filters-drawer' | null;
}
